export interface PublicLeadFormData {
  name: string;
  email: string;
  company: string;
  interest: string;
  quelle?: string;
  /** Honeypot — Bots füllen versteckte Felder; niemals anzeigen. */
  website?: string;
  idempotencyKey?: string;
}

export type LeadSubmitStatus = 'success' | 'partial' | 'error';

export interface LeadSubmitResult {
  ok: boolean;
  status?: LeadSubmitStatus;
  blocked?: boolean;
  message?: string;
  emailSent?: boolean;
  pbSaved?: boolean;
  pbId?: string;
}

export const LEAD_USER_MESSAGES = {
  success: 'Anfrage erhalten — wir melden uns innerhalb von 48 Stunden.',
  partial:
    'Anfrage gespeichert — E-Mail-Benachrichtigung konnte nicht versendet werden. Wir prüfen das.',
  networkError:
    'Die Anfrage konnte gerade nicht übermittelt werden. Bitte an office@arkorbit.at schreiben.',
  webhookError:
    'Die Anfrage konnte nicht gespeichert werden. Bitte an office@arkorbit.at schreiben.',
} as const;
